import { isPatternParsingError, patternAsString, stringAsPattern } from "../pattern/serializePattern";
import { IpaType } from "../phonemes/ipa";
import { StressMatch } from "./stressRule";

/** simple serialization of StressMatch rules */
export function stressMatchesToString(toCheck?: StressMatch<IpaType>[]): string | undefined {
  if (toCheck === undefined) {
    return undefined;
  }
  const checks = toCheck.map(tc => {
    const pattern = patternAsString(tc.pattern);
    return `${tc.which} ${pattern}\n`;
  });
  return checks.join('');
}

export interface StressParseError {
  readonly stressLine: number;
  readonly error: 'expected number' | 'expected pattern';
  readonly got?: string;
}
export function isStressParseError(check: unknown): check is StressParseError {
  const test = check as StressParseError;
  return test && (test.stressLine !== undefined || test.error !== undefined);
}
export function stressParseErrorToString(error: StressParseError): string {
  const s = `${error.error} on line number ${error.stressLine}`;
  return s;
}

/** reverse of stressMatchesToString */
export function stringToStressMatches(s: string): StressMatch<IpaType>[] | StressParseError {
  const results: StressMatch<IpaType>[] = [];
  const lines = s.split('\n');
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    if (line === '') {
      continue;
    }

    const where = line.indexOf(' ');
    const space = where !== -1 ? where : line.length;

    const whichStr = line.substring(0, space).trim();
    const which = Number.parseInt(whichStr);
    if (Number.isNaN(which)) {
      return { stressLine: i + 1, error: 'expected number', got: line.substring(0, space) };
    }
    const patternStr = line.substring(space + 1).trim();
    const pattern = stringAsPattern(patternStr);
    if (pattern === null) {
      return { stressLine: i + 1, error: 'expected pattern' };
    } else if (isPatternParsingError(pattern)) {
      return { stressLine: i + 1, error: 'expected pattern', got: pattern.context };
    }
    results.push({ which, pattern });
  }
  return results;
}
